import posthog from 'posthog-js';

// Initialize PostHog
if (import.meta.env.VITE_POSTHOG_KEY && import.meta.env.PROD) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
  });
}

export const analytics = {
  identify: (userId, properties = {}) => {
    if (import.meta.env.PROD) posthog.identify(userId, properties);
  },
  track: (event, properties = {}) => {
    if (import.meta.env.PROD) posthog.capture(event, properties);
  },
  reset: () => {
    if (import.meta.env.PROD) posthog.reset();
  },
};
